import script from "./EditableField.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableField.vue?vue&type=script&setup=true&lang=js"

import "./EditableField.vue?vue&type=style&index=0&id=03bd80df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03bd80df"]])

export default __exports__